import { AvailabilityStatementType } from '../../../../../packages/apis/src/shopify/types/OnlineProduct';

export type ProductSchemaAvailabilityType =
  | 'InStock'
  | 'LimitedAvailability'
  | 'PreOrder'
  | 'SoldOut'
  | 'BackOrder'
  | 'InStoreOnly'
  | 'OnlineOnly'
  | 'OutOfStock'
  | 'ComingSoon';

export const mapAvailabilityStatementToSchema = (
  availabilityStatement: AvailabilityStatementType | undefined
): ProductSchemaAvailabilityType => {
  switch (availabilityStatement) {
    case 'Limited stock':
    case 'Limited stock online':
      return 'LimitedAvailability';

    case 'Coming soon':
      return 'ComingSoon';

    case 'Pre-order online':
      return 'PreOrder';

    case 'No longer available':
    case 'Temporarily unavailable':
    case 'Temporarily unavailable online':
      return 'SoldOut';

    case 'Awaiting stock':
    case 'Back order available':
      return 'BackOrder';

    case 'Limited stock in store':
    case 'In stock in store':
      return 'InStoreOnly';

    case 'Digital delivery':
      return 'OnlineOnly';

    case 'In stock online':
    case 'In stock':
    case 'Free postal delivery':
      return 'InStock';

    default:
      return 'OutOfStock';
  }
};
